export default "__VITE_ASSET__UlBx8pFd__"